interface Transaction {
  id: string;
  credits: number;
  transaction_type: string;
  description: string;
  created_at: string;
}

interface CreditTransactionsProps {
  transactions: Transaction[];
}

export default function CreditTransactions({ transactions }: CreditTransactionsProps) {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getTransactionTypeLabel = (type: string) => {
    const labels: Record<string, string> = {
      subscription: 'Subscription',
      one_time_purchase: 'One-Time Purchase',
      usage: 'Usage',
      refund: 'Refund',
      adjustment: 'Adjustment',
    };
    return labels[type] || type;
  };

  return (
    <div className="glass-card rounded-xl p-6">
      {transactions.length === 0 ? (
        <p className="text-center py-8 text-gray-500 dark:text-gray-400">
          No transactions yet
        </p>
      ) : (
        <div className="overflow-x-auto">
          <div className="max-h-96 overflow-y-auto">
            <table className="w-full">
              <thead className="sticky top-0 bg-white dark:bg-slate-800 z-10">
                <tr className="border-b border-gray-200 dark:border-slate-700">
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-900 dark:text-white">
                    Date
                  </th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-900 dark:text-white">
                    Type
                  </th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-900 dark:text-white">
                    Description
                  </th>
                  <th className="text-right py-3 px-4 text-sm font-semibold text-gray-900 dark:text-white">
                    Credits
                  </th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((transaction) => (
                  <tr
                    key={transaction.id}
                    className="border-b border-gray-100 dark:border-slate-800 hover:bg-gray-50 dark:hover:bg-slate-800/50 transition"
                  >
                    <td className="py-3 px-4 text-sm text-gray-600 dark:text-gray-400">
                      {formatDate(transaction.created_at)}
                    </td>
                    <td className="py-3 px-4 text-sm text-gray-600 dark:text-gray-400">
                      {getTransactionTypeLabel(transaction.transaction_type)}
                    </td>
                    <td className="py-3 px-4 text-sm text-gray-600 dark:text-gray-400">
                      {transaction.description || '-'}
                    </td>
                    <td
                      className={`py-3 px-4 text-sm text-right font-semibold ${
                        transaction.credits > 0
                          ? 'text-green-600 dark:text-green-400'
                          : 'text-red-600 dark:text-red-400'
                      }`}
                    >
                      {transaction.credits > 0 ? '+' : ''}
                      {transaction.credits.toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

